import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getEmployeeById } from "../../../api/employeeDocument";
import {
  createSalary,
  updateSalary,
  getSalaryById,
} from "../../../api/salary";
import toast from "react-hot-toast";

const CreateSalaryDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [employeeId, setEmployeeId] = useState("");
  const [employeeData, setEmployeeData] = useState(null);

  const [data, setData] = useState({
    creditDate: "",
    creditTime: "",
    amount: "",
    companyBank: "",
    employeeBank: "",
    companyAccount: "",
    employeeAccount: "",
    dateofjoining: "",
    month: "",
    year: "",
    status: "Credited",
  });

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

  /* ================= FETCH EMPLOYEE ================= */
const fetchEmployee = async () => {
  if (!employeeId) {
    toast.error("Enter Employee ID ⚠️");
    return;
  }

  try {
    const res = await getEmployeeById(employeeId);
    const emp = res?.data || res;

    if (!emp) {
      setEmployeeData(null);
      toast.error("Employee Not Found ❌");
      return;
    }

    setEmployeeData(emp);

    setData((prev) => ({
      ...prev,
      dateofjoining: emp?.dateofjoining || "",
    }));

    toast.success("Employee Loaded ✅");

  } catch (err) {
    setEmployeeData(null);
    toast.error("Employee Not Found ❌");
  }
};

  /* ================= CHANGE ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

   if (!employeeData) {
  toast.error("Fetch employee first ❌");
  return;
}
   

    const payload = {
      employeeId,
      employeeName: `${employeeData.firstName} ${employeeData.lastName}`,
      ...data,
    };

    try {
      if (id) {
        await updateSalary(id, payload);
        toast.success("Salary Updated ✅");
      } else {
        await createSalary(payload);
        toast.success("Salary Created ✅");
      }

      navigate("/salary-detail-list");

    } catch (err) {
      toast.success("Salary Created ✅");
    }
  };

  /* ================= EDIT LOAD ================= */
  useEffect(() => {
    if (id) {
      (async () => {
        const res = await getSalaryById(id);
        const s = res.data.data;

        setEmployeeId(s.employeeId);
        setData(s);

        const emp = await getEmployeeById(s.employeeId);
        setEmployeeData(emp?.data || emp);
      })();
    }
  }, [id]);

  const bankOptions = [
  { name: "IndusInd Bank", account: "258098066668" },
  { name: "Kotak Bank", account: "8098066668" },
  { name: "RBL Bank", account: "409962666449" },
  { name: "Shinhan Bank", account: "701000039189" },
];

  return (
    <div className="salary-page container mt-4">

      {/* TITLE */}
      <div className="page-header mb-4">
        <h2>{id ? "Edit Salary Details" : "Create Salary Details"}</h2>
        <p className="text-muted">Manage employee salary information</p>
      </div>

      {/* SEARCH SECTION */}
      <div className=" shadow-sm p-3 mb-4">
        <div className="row align-items-center">

          {/* LEFT - SEARCH INPUT */}
          <div className="col-lg-6">
            <label className="form-label">Employee ID</label>

            <div className="d-flex">
              <input
                className="form-control"
                placeholder="Enter Employee ID"
                value={employeeId}
                onChange={(e) => setEmployeeId(e.target.value)}
                disabled={id}
              />

              {!id && (
                <button onClick={fetchEmployee} className="search-button">
                  Search
                </button>
              )}
            </div>
          </div>

          {/* RIGHT - EMPLOYEE INFO */}
          {employeeData && (
            <div className="col-lg-6 d-flex justify-content-end">

              <div className="search-right d-flex align-items-center">

                <img
                  src={employeeData.profileImage}
                  alt="profile"
                  className="search-emp-img"
                />

                <div className="emp-details ms-3">
                  <h5 className="mb-1">
                    {employeeData.firstName} {employeeData.lastName}
                  </h5>

                  <p><span>Designation:</span> {employeeData.designation}</p>
                  <p><span>Email:</span> {employeeData.officialmailid}</p>
                  <p><span>Phone:</span> {employeeData.mobilenumber}</p>
                  <p><span>Location:</span> {employeeData.location}</p>
                </div>

              </div>

            </div>
          )}

        </div>
      </div>

      {/* FORM */}
      {(employeeData || id) && (
        <form onSubmit={handleSubmit}>

          <div className="row">

            {/* FULL WIDTH (col-lg-12) */}
            <div className="col-lg-12">

              {/* SALARY CARD */}
              <div className=" shadow-sm p-4 mb-4">
                <h5 className="section-title">💰 Salary Details</h5>

                <div className="mb-3">
                  <label>Amount</label>
                  <input
                    name="amount"
                    className="form-control"
                    value={data.amount}
                    onChange={handleChange}
                  />
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label>Credit Date</label>
                    <input
                      type="date"
                      name="creditDate"
                      className="form-control"
                      value={data.creditDate}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label>Credit Time</label>
                    <input
                      type="time"
                      name="creditTime"
                      className="form-control"
                      value={data.creditTime}
                      onChange={handleChange}
                    />
                  </div>
                </div>

              <div className="mb-3">
  <label>Company Bank</label>
  <select
    name="companyBank"
    className="form-control"
    value={data.companyBank}
    onChange={(e) => {
      const selectedBank = bankOptions.find(
        (b) => b.name === e.target.value
      );

      setData((prev) => ({
        ...prev,
        companyBank: selectedBank.name,
        companyAccount: selectedBank.account, // ✅ AUTO FILL
      }));
    }}
  >
    <option value="">Select Bank</option>
    {bankOptions.map((bank, i) => (
      <option key={i} value={bank.name}>
        {bank.name}
      </option>
    ))}
  </select>
</div>

                <div className="mb-3">
                  <label>Employee Bank</label>
                  <input
                    name="employeeBank"
                    className="form-control"
                    value={data.employeeBank}
                    onChange={handleChange}
                  />
                </div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label>Company Account Number</label>
                    <input
                      name="companyAccount"
                      className="form-control"
                      placeholder="Enter Company A/C No"
                      value={data.companyAccount}
                      onChange={handleChange}
                        readOnly 
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label>Employee Account Number</label>
                    <input
                      name="employeeAccount"
                      className="form-control"
                      placeholder="Enter Employee A/C No"
                      value={data.employeeAccount}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              {/* EMPLOYMENT CARD */}
              <div className=" shadow-sm p-4">
                <h5 className="section-title">📅 Employment Info</h5>

                {/* <div className="mb-3">
                  <label>Date of Joining</label>
                  <input
                    type="date"
                    name="dateofjoining"
                    className="form-control"
                    value={data.dateofjoining}
                    onChange={handleChange}
                  />
                </div> */}

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label>Month</label>
                    <select
                      name="month"
                      className="form-control"
                      value={data.month}
                      onChange={handleChange}
                    >
                      <option value="">Select Month</option>
                      {months.map((m, i) => (
                        <option key={i} value={m}>{m}</option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label>Year</label>
                    <select
                      name="year"
                      className="form-control"
                      value={data.year}
                      onChange={handleChange}
                    >
                      <option value="">Select Year</option>
                      {years.map((y, i) => (
                        <option key={i} value={y}>{y}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

            </div>

          </div>

          {/* SUBMIT BUTTON */}
          <div className="text-end mt-4">
            <button className="btn btn-success px-4">
              {id ? "Update Salary" : "Save Salary"}
            </button>
          </div>

        </form>
      )}

    </div>
  );
};

export default CreateSalaryDetails;